import React, { useState, useEffect } from 'react';
import { unitAPI } from '../../services/api';
import { toast } from 'react-toastify';
import PageTitle from '../shared/PageTitle';

const GuardVillas = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        setLoading(true);
        const response = await unitAPI.getAllUnits();
        console.log('Units fetched:', response.data);
        setUnits(response.data || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching units:', err);
        setError('Failed to load units');
        toast.error('Failed to load units');
      } finally {
        setLoading(false);
      }
    };

    fetchUnits();
  }, []);

  return (
    <div className="container mt-4">
      <PageTitle icon="fa-building" title="Unit Directory" />
      
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <>
          <div className="alert alert-info mb-4">
            View unit information and resident details.
          </div>
          
          <div className="row">
            {units.map(unit => (
              <div className="col-md-4 mb-4" key={unit.id}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title p-2 mb-3">Unit {unit.villa_number}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">
                      {unit.unit_type || 'Standard Unit'}
                    </h6>
                    <p className="card-text">
                      <strong>Status:</strong> {unit.status || 'Unknown'}<br />
                      <strong>Owner:</strong> {unit.owner_name || 'Not Assigned'}<br />
                      {unit.contact_phone && (
                        <><strong>Contact:</strong> {unit.contact_phone}<br /></>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            
            {units.length === 0 && (
              <div className="col-12">
                <div className="alert alert-warning">
                  No units found.
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default GuardVillas;